// extracted by mini-css-extract-plugin
export default {"dropdownContent":"ContextMenu_dropdownContent__+bMUh"};